import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { RaisedButton } from 'material-ui';
import RewardIcon from '../../icons/RewardIcon';
import {BODY_TEXT_COLOR} from '../../config/colors';


const styles = {
    editIcon: { width: '30px', height: '30px' },
    deliveryIcon: {
      margin: '0 10px'
    },
    title: { fontWeight: '600', marginBottom: '10px', color: '#616161' },
    editAddressStyle: { position: 'absolute', cursor: 'pointer', right: '18px', top: '0' },
    textArea: { display: 'block' },
    deliveryNotes: { fontWeight: '600', marginBottom: '10px', color: '#616161' },
    contMargin: { marginLeft: '10px' },
    inputStyle: {
        paddingLeft: 12,
        height: 30,
        marginRight: 12,
        marginBottom: 12
    },
    validationErrorStyle: {
        color: '#ff3333'
    },
    discountDisclaimer: {
        textTransform: 'none',
        fontStyle: 'italic',
    }
  };

class RedeemRewards extends Component {
    constructur() {
        this.state = {
            rewardDollarsToRedeem: 0,
            validationError: "",
        }
    }

    validateAndReturnValidationErrorMessage(){
        const {
            rewardDollarsToRedeem
        } = this.state;

        let validationError = "";

        if (isNaN(rewardDollarsToRedeem)) {
            validationError = "Must be a number";
        }

        if (rewardDollarsToRedeem < 0) {
            validationError = "Cannot Redeem a Negative Amount of Rewards";
        } 
        
        if (rewardDollarsToRedeem > (this.props.subTotal - 1)) {
            validationError = "You can only discount down to $1.00";
        } 

        if (rewardDollarsToRedeem > this.props.totalRewards) {
            validationError = "Insufficient rewards balance";
        }

        if (rewardDollarsToRedeem * 100 % 1 != 0) {
            validationError = "Cannot use a fraction of a cent";
        }

        this.setState({validationError})

        return validationError;
    }

    render() {
        const {
            totalRewards,
            currentlyRedeeming,
            rewardsBalance,
            applyRewards
        } = this.props;

    

            return (
                <div className="treez-checkout-items-details">
                  <div style={styles.deliveryIcon}>
                    <RewardIcon 
                        color={BODY_TEXT_COLOR}
                    />
                  </div>
                  <div className="treez-checkout-items-details-left" style={styles.contMargin}>
                    <div style={styles.title}>
                        REDEEM REWARDS
                    </div>
                    <div>
                        Current Rewards: <b>{totalRewards.formatMoney()} </b>
                    </div>
                    <div>
                        <input 
                            style={styles.inputStyle}
                            type='number'
                            placeholder='Enter Reward Dollars'
                            onChange={(event) => {
                                this.setState({
                                    rewardDollarsToRedeem: event.target.value
                                })
                            }}
                        />
                        <RaisedButton
                        backgroundColor={this.props.secondaryColor}
                        labelStyle={{ fontWeight: 700 }}
                        labelColor="#FFF"
                        label="Apply"
                        buttonStyle={{}}
                        onClick={() => {
                            if (
                                this.state &&
                                !this.validateAndReturnValidationErrorMessage()
                            ) {
                                applyRewards(this.state.rewardDollarsToRedeem || 0.00)
                            }
                        }}
                        />
                    </div>
                    {
                        currentlyRedeeming > 0 
                        && <div>
                            <div>Rewards Applied <b>${this.props.currentlyRedeeming}</b></div>
                            <div>({rewardsBalance.formatMoney()} Remaining)</div>
                        </div>
                    }
                    {
                        (this && this.state && this.state.validationError) &&
                        <div style={styles.validationErrorStyle}>
                            {this.state.validationError}
                        </div>
                    }
                    <div style={styles.discountDisclaimer}>
                        Rewards will be applied as a discount. <br/> Rewards balance will be adjusted after you receive your product(s). 
                    </div>
                  </div>
                </div>
          )
    }
}

RedeemRewards.propTypes = {
    rewardsBalance: PropTypes.number,
    applyRewards: PropTypes.func.isRequired,
    secondaryColor: PropTypes.string.isRequired,
    subTotal: PropTypes.number.isRequired
}

export default RedeemRewards;



// WEBPACK FOOTER //
// ./src/components/Checkout/RedeemRewards.jsx